import { z } from 'zod';

export const orderAlertLevelSchema = z.enum(['info', 'warning', 'danger']);
export type OrderAlertLevel = z.infer<typeof orderAlertLevelSchema>;

export const orderAlertSchema = z.object({
  /** the title of the alert such `Payment Info` */
  title: z.coerce.string().trim(),
  /** the message of the alert such `The user must pay before unloading items` */
  message: z.coerce.string().trim(),
  /**
   * the level of alert
   * - `info` = means general information `Blue color`
   * - `warning` = important message to be read by the user `Yellow Color`
   * - `danger` = very very important message to be read by the user such as the order NOT paid `Red Color`
   */
  level: orderAlertLevelSchema,
});
export type OrderAlert = z.infer<typeof orderAlertSchema>;
